import React from "react";
import { motion } from "framer-motion";
import { springVariants, springViewport } from "../utils/framerVariants";

const Downloads = ({ data: { Text, Downloads } }) => {
  return (
    <article className="container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl px-4 md:px-24 xl:px-24 mb-16 md:mb-24 lg:mb-32 xl:mb-48">
      {Text &&
        <motion.div
          variants={springVariants}
          initial="invisible"
          whileInView="visible"
          viewport={springViewport}
          className="mb-8 sm:mb-16 richtextdownloads"
          dangerouslySetInnerHTML={{
            __html: Text,
          }}
        />
      }
      <div className="grid grid-cols-1 simple media-downloads divide-y-3 divide-black mt-16">
        {Downloads.map((entry, i) => (
          <motion.div
            variants={springVariants}
            initial="invisible"
            whileInView="visible"
            viewport={springViewport}
            className="col-span-1" key={i}>
            <div className="flex items-center h-24 justify-center">
              <div className="grow pr-4 sm:pr-0">
              {entry.Download && entry.Download.file && entry.Download.file.url && (
                <a
                  href={entry.Download.file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-headline-md tracking-headline-md leading-[1] font-bold allianz-link"
                >
                  <span>{entry.Name}</span>
                </a>
              )}
              </div>
              <div className="flex-none">
                <p className="text-text-sm tracking-text-sm leading-[1] text-text-sm font-semibold text-white">
                  <span className="inline-flex items-center rounded-md bg-black px-2 py-1 pb-1.5">
                    {entry.Download && entry.Download.mime.split("/")[1]}
                  </span>
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </article>
  );
};

export default Downloads;
